import { global } from '#blokkli-build/chunk-global.js'

export const chunks = {
  global,
  rare: () => import('#blokkli-build/chunk-rare.js').then(v => v['rare'])
}

export const chunkMapping = {
  'block:accordeon': 'global',
  'block:blokkli_fragment': 'global',
  'block:button': 'global',
  'block:call_to_action_section': 'global',
  'block:carousel': 'global',
  'block:chart': 'global',
  'block:contact_box': 'global',
  'block:divider': 'global',
  'block:from_library': 'global',
  'block:icon_text_item': 'global',
  'block:icon_text_list': 'global',
  'block:iframe': 'global',
  'block:image': 'global',
  'block:infobox': 'global',
  'block:media_list': 'global',
  'block:milestones': 'global',
  'block:quote': 'global',
  'block:table': 'global',
  'block:teaser': 'global',
  'block:teaser_list': 'global',
  'block:teaser_with_external_link': 'global',
  'block:text': 'global',
  'block:text_image': 'global',
  'block:video': 'global',
  'block:view': 'rare',
  'block:webform': 'rare',
  'fragment:Test': 'global'
}